import data from './Mapping'
import router from "../router/index"

const utils = {
 // 审批状态转化
 subAppStatus (status) {
  return data.STATUSLIST.filter((i) => i.id === status)[0] ? data.STATUSLIST.filter((i) => i.id === status)[0].name : ''
 },
 // 路由跳转携带ticket this.$utils.routerPush
 routerPush (params) {
  if (router.history.current.query.ticket) {
   if (typeof params === 'string') {
    router.push({
     path: params,
     query: {
      ticket: router.history.current.query.ticket
     }
    })
   } else {
    let query = params.query ? { ...params.query, ticket: router.history.current.query.ticket } : { ticket: router.history.current.query.ticket }
    let obj = {
     ...params,
     query
    }
    router.push(obj)
   }
  } else {
   router.push(params)
  }
 },
 scrollPage (className, fn) {
  let dom = document.querySelector(className ? className : '.scroll-box-tab')
  // return new Promise((resolve) => {
  dom.addEventListener('scroll', function () {
   var scrollHeight = dom.scrollHeight
   var clientHeight = dom.clientHeight
   var scrollTop = dom.scrollTop
   if (scrollTop + clientHeight >= scrollHeight) {
    // resolve()
    console.log('已经滚动到底部！')
    fn()
   }
  }, false)
  // })

 }
}


export default utils


// WEBPACK FOOTER //
// ./src/utils/index.js